export default __webpack_public_path__ + "static/media/imageLogo3.3bc312e6.png";